// Version : 0.0.1
// Author : VISHAL BHARATHI
// LastEdit : VISHAL BHARATHI
// Last ADD : INTEREST WAIVER ADDED
// MODFIED DATA : 19-08-2025

/* eslint-disable import/no-anonymous-default-export */
import AutoLoanCollectionTypes from './auto-loan-collection.types';
import { docodeHexResponse } from '../../../_common/common.utils';

const INITIAL_STATE = {
	fetchAutoLoanIndexListResp: null,
	fetchAutoLoanIndexListArr: [],
	fetchAutoLoanCollectionListResp: null,
	fetchAutoLoanCollectionListArr: [],
	updateAutoLoanCollectionResp: null,
	revertAutoLoanCollectionResp: null,
	autoLoanMemberDeleteSavingResp: null,
	updatedAutoLoanInterestWaiverResponse: null,
	autoLoanCollectionApprovalResponse: null,
	autoLoanCollectionApprovalArr: [],
	autoLoanCollectionVehicleSeizedResponse: null,
	addAutoLoanMemberWalletResp: null,
	fetchAutoLoanRepaymentResp: null,
	fetchAutoLoanRepaymentArr: [],
	fetchAutoLoanArrearCollectionsResp: null,
	fetchAutoLoanArrearCollectionsArr: [],
	fetchAutoLoanVehicleDetailsResp: null,
	fetchAutoLoanVehicleDetailsArr: [],
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** *********************  AUTO LOAN INDEX LIST DETAILS START  ******************** */
		case AutoLoanCollectionTypes.FETCH_AUTO_LOAN_INDEX_LIST_SUCCESS:
			return {
				...state,
				fetchAutoLoanIndexListResp: action.payload,
				fetchAutoLoanIndexListArr: docodeHexResponse(
					action.payload,
					'FetchAutoLoanIndexListKey',
				),
			};

		case AutoLoanCollectionTypes.FETCH_AUTO_LOAN_INDEX_LIST_FAILURE:
			return { ...state, fetchAutoLoanIndexListResp: action.payload };

		case AutoLoanCollectionTypes.FETCH_AUTO_LOAN_INDEX_LIST_RESPONSE_CHANGED:
			return { ...state, fetchAutoLoanIndexListResp: null };

		/** *********************  AUTO LOAN INDEX LIST DETAILS START  ******************** */

		/** *********************  AUTO LOAN COLLECTION LIST DETAILS START  ******************** */
		case AutoLoanCollectionTypes.FETCH_AUTO_LOAN_COLLECTION_LIST_SUCCESS:
			return {
				...state,
				fetchAutoLoanCollectionListResp: action.payload,
				fetchAutoLoanCollectionListArr: docodeHexResponse(
					action.payload,
					'getAutoLoanCollectionKey',
				),
			};

		case AutoLoanCollectionTypes.FETCH_AUTO_LOAN_COLLECTION_LIST_FAILURE:
			return { ...state, fetchAutoLoanCollectionListResp: action.payload };

		case AutoLoanCollectionTypes.FETCH_AUTO_LOAN_COLLECTION_LIST_RESPONSE_CHANGED:
			return { ...state, fetchAutoLoanCollectionListResp: null };

		/** *********************  AUTO LOAN COLLECTION LIST DETAILS END  ******************** */

		case AutoLoanCollectionTypes.UPDATE_AUTO_LOAN_COLLECTION_SUCCESS:
			return {
				...state,
				updateAutoLoanCollectionResp: action.payload,
			};

		case AutoLoanCollectionTypes.UPDATE_AUTO_LOAN_COLLECTION_FAILURE:
			return {
				...state,
				updateAutoLoanCollectionResp: action.payload,
			};

		case AutoLoanCollectionTypes.UPDATE_AUTO_LOAN_COLLECTION_RESPONSE_CHANGED:
			return { ...state, updateAutoLoanCollectionResp: null };

		/** ***************** UPDATE AUTO LOAN COLLECTION ******************************* */

		/** ***************** REVERT AUTO LOAN COLLECTION START ******************************* */
		case AutoLoanCollectionTypes.REVERT_AUTO_LOAN_COLLECTION_SUCCESS:
			return {
				...state,
				revertAutoLoanCollectionResp: action.payload,
			};

		case AutoLoanCollectionTypes.REVERT_AUTO_LOAN_COLLECTION_FAILURE:
			return {
				...state,
				revertAutoLoanCollectionResp: action.payload,
			};

		case AutoLoanCollectionTypes.REVERT_AUTO_LOAN_COLLECTION_RESPONSE_CHANGED:
			return { ...state, revertAutoLoanCollectionResp: null };

		/** ***************** REVERT AUTO LOAN COLLECTION END ******************************* */

		/** ***************** AUTO LOAN MEMBER DELETE SAVING START ******************************* */
		case AutoLoanCollectionTypes.REVERT_AUTO_LOAN_MEMBER_WALLET_SUCCESS:
			return {
				...state,
				autoLoanMemberDeleteSavingResp: action.payload,
			};

		case AutoLoanCollectionTypes.REVERT_AUTO_LOAN_MEMBER_WALLET_FAILURE:
			return {
				...state,
				autoLoanMemberDeleteSavingResp: action.payload,
			};

		case AutoLoanCollectionTypes.REVERT_AUTO_LOAN_MEMBER_WALLET_RESPONSE_CHANGED:
			return { ...state, autoLoanMemberDeleteSavingResp: null };

		/** ***************** AUTO LOAN MEMBER DELETE SAVING END ******************************* */

		/** ***************** UPDATE AUTO LOAN INTEREST WAIVER  START *********************** */
		case AutoLoanCollectionTypes.UPDATE_AUTO_LOAN_INTEREST_WAIVER_SUCCESS:
			return { ...state, updatedAutoLoanInterestWaiverResponse: action.payload };

		case AutoLoanCollectionTypes.UPDATE_AUTO_LOAN_INTEREST_WAIVER_FAILURE:
			return { ...state, updatedAutoLoanInterestWaiverResponse: action.payload };

		case AutoLoanCollectionTypes.UPDATE_AUTO_LOAN_INTEREST_WAIVER_RESPONSE_CHANGED:
			return { ...state, updatedAutoLoanInterestWaiverResponse: null };
		/** ***************** UPDATE AUTO LOAN INTEREST WAIVER END *********************** */

		/***************** AUTO LOAN COLLECTION APPROVAL START ***********************/
		case AutoLoanCollectionTypes.AUTO_LOAN_COLLECTION_APPROVAL_SUCCESS:
			return {
				...state,
				autoLoanCollectionApprovalResponse: action.payload,
			};

		case AutoLoanCollectionTypes.AUTO_LOAN_COLLECTION_APPROVAL_FAILURE:
			return {
				...state,
				autoLoanCollectionApprovalResponse: action.payload,
			};

		case AutoLoanCollectionTypes.AUTO_LOAN_COLLECTION_APPROVAL_RESPONSE_CHANGED:
			return { ...state, autoLoanCollectionApprovalResponse: null };

		/*****************  AUTO LOAN COLLECTION APPROVAL END ***********************/

		/***************** AUTO LOAN COLLECTION VEHICLE SEIZED START ***********************/
		case AutoLoanCollectionTypes.AUTO_LOAN_COLLECTION_VEHICLE_SEIZED_SUCCESS:
			return {
				...state,
				autoLoanCollectionVehicleSeizedResponse: action.payload,
			};

		case AutoLoanCollectionTypes.AUTO_LOAN_COLLECTION_VEHICLE_SEIZED_FAILURE:
			return {
				...state,
				autoLoanCollectionVehicleSeizedResponse: action.payload,
			};

		case AutoLoanCollectionTypes.AUTO_LOAN_COLLECTION_VEHICLE_SEIZED_RESPONSE_CHANGED:
			return { ...state, autoLoanCollectionVehicleSeizedResponse: null };

		/*****************  AUTO LOAN COLLECTION VEHICLE SEIZED END ***********************/

		/** ********************* ADD AUTO LOAN MEMBER WALLET START ******************** */

		case AutoLoanCollectionTypes.ADD_AUTO_LOAN_MEMBER_WALLET_SUCCESS:
			return { ...state, addAutoLoanMemberWalletResp: action.payload };

		case AutoLoanCollectionTypes.ADD_AUTO_LOAN_MEMBER_WALLET_FAILURE:
			return { ...state, addAutoLoanMemberWalletResp: action.payload };

		case AutoLoanCollectionTypes.ADD_AUTO_LOAN_MEMBER_WALLET_RESPONSE_CHANGED:
			return { ...state, addAutoLoanMemberWalletResp: null };

		/** ********************* ADD AUTO LOAN MEMBER WALLET END ******************** */

		/** *********************  FETCH AUTO LOAN REPAYMENT START  ******************** */
		case AutoLoanCollectionTypes.FETCH_AUTO_LOAN_REPAYMENT_SUCCESS:
			return {
				...state,
				fetchAutoLoanRepaymentResp: action.payload,
				fetchAutoLoanRepaymentArr: docodeHexResponse(
					action.payload,
					'FetchAutoLoanRepaymentKey',
				),
			};

		case AutoLoanCollectionTypes.FETCH_AUTO_LOAN_REPAYMENT_FAILURE:
			return { ...state, fetchAutoLoanRepaymentResp: action.payload };

		case AutoLoanCollectionTypes.FETCH_AUTO_LOAN_REPAYMENT_RESPONSE_CHANGED:
			return { ...state, fetchAutoLoanRepaymentResp: null };

		/** *********************  FETCH AUTO LOAN REPAYMENT END  ******************** */

		/** *********************  FETCH AUTO LOAN ARREAR COLLECTIONS START  ******************** */
		case AutoLoanCollectionTypes.FETCH_AUTO_LOAN_ARREAR_COLLECTIONS_SUCCESS:
			return {
				...state,
				fetchAutoLoanArrearCollectionsResp: action.payload,
				fetchAutoLoanArrearCollectionsArr: docodeHexResponse(
					action.payload,
					'FetchAutoLoanArrearCollectionsKey',
				),
			};

		case AutoLoanCollectionTypes.FETCH_AUTO_LOAN_ARREAR_COLLECTIONS_FAILURE:
			return { ...state, fetchAutoLoanArrearCollectionsResp: action.payload };

		case AutoLoanCollectionTypes.FETCH_AUTO_LOAN_ARREAR_COLLECTIONS_RESPONSE_CHANGED:
			return { ...state, fetchAutoLoanArrearCollectionsResp: null };

		/** *********************  FETCH AUTO LOAN ARREAR COLLECTIONS END  ******************** */

		/** *********************  FETCH AUTO LOAN VEHICLE DETAILS START  ******************** */
		case AutoLoanCollectionTypes.FETCH_AUTO_LOAN_VEHICLE_DETAILS_SUCCESS:
			return {
				...state,
				fetchAutoLoanVehicleDetailsResp: action.payload,
				fetchAutoLoanVehicleDetailsArr: docodeHexResponse(
					action.payload,
					'FetchAutoLoanVehicleKey',
				),
			};

		case AutoLoanCollectionTypes.FETCH_AUTO_LOAN_VEHICLE_DETAILS_FAILURE:
			return { ...state, fetchAutoLoanVehicleDetailsResp: action.payload };

		case AutoLoanCollectionTypes.FETCH_AUTO_LOAN_VEHICLE_DETAILS_RESPONSE_CHANGED:
			return { ...state, fetchAutoLoanVehicleDetailsResp: null };

		/** *********************  FETCH AUTO LOAN VEHICLE DETAILS END  ******************** */

		default:
			return state;
	}
};
